const VARIANTS = {
  // brand-* and on-brand text are theme tokens (index.css) that repaint
  // under [data-theme="dark"] on their own — dark:text-slate-900 is the one
  // manual override, since --on-brand flips from white to near-black
  // (brand-600 itself gets lighter in the dark, per design-system.md).
  primary: 'bg-brand-600 text-white hover:bg-brand-700 disabled:bg-brand-200 dark:text-slate-900',
  secondary: 'bg-white text-brand-700 ring-1 ring-brand-200 hover:bg-brand-50 dark:bg-slate-800',
  ghost: 'text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-700',
  danger: 'bg-rose-600 text-white hover:bg-rose-700',
}

const SIZES = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2.5 text-sm',
  lg: 'px-6 py-3 text-base',
}

export default function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  className = '',
  children,
  ...props
}) {
  return (
    <button
      // aria-busy rather than swapping the label: a screen reader announces
      // the state change without the accessible name shifting under it.
      aria-busy={loading || undefined}
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center gap-2 rounded-xl font-medium
        transition-colors disabled:cursor-not-allowed ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      {...props}
    >
      {loading && (
        <span
          aria-hidden="true"
          className="size-4 animate-spin rounded-full border-2 border-current border-t-transparent"
        />
      )}
      {children}
    </button>
  )
}
